/* unplugin-vue-components disabled */import { render } from "./TwoLinesText.vue?vue&type=template&id=1aca47da"
import script from "./TwoLinesText.vue?vue&type=script&lang=js"
export * from "./TwoLinesText.vue?vue&type=script&lang=js"

import "./TwoLinesText.vue?vue&type=style&index=0&id=1aca47da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__